
/**
 * @export
 * @enum {string}
 */
export enum LicenseType {
    TD = 'TD',
    TR = 'TR',
    SB = 'SB',
    BVR = 'BVR',
    CU = 'CU',
    UN = 'UN',
    CN = 'CN',
    PF = 'PF',
    RC = 'RC',
    RT = 'RT',
    US = 'US',
    IR = 'IR',
    GP = 'GP',
    UGP = 'UGP'
}